import { render, staticRenderFns } from "./ClientCardView.vue?vue&type=template&id=d33273f2&"
import script from "./ClientCardView.vue?vue&type=script&lang=js&"
export * from "./ClientCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports